import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { getOrganizationAxios } from "api-hooks/get-organization-axios"
import { useIsAuthenticated } from "core/hooks"

export interface OnboardingState {
  completed_at: string | null
  last_completed_step: number | null
  completed_by: string | null
  org_type: string | null
  referral_source: string | null
  referral_source_other: string | null
  primary_goal: string | null
  use_case: string | null
}

export interface SaveOnboardingStepParams {
  organization_id: string
  step: number
  org_type?: string
  referral_source?: string
  referral_source_other?: string | null
  primary_goal?: string
  use_case?: string
  completed?: boolean
}

export function useOnboardingState(organizationId: string | undefined) {
  const isAuthenticated = useIsAuthenticated()

  return useQuery<OnboardingState>({
    queryKey: ["onboarding", organizationId],
    queryFn: async () => {
      const axios = getOrganizationAxios()
      const { data } = await axios.get(
        `/api/internal/organizations/${organizationId}/get_onboarding`
      )
      return data
    },
    enabled: isAuthenticated && !!organizationId,
    retry: false,
  })
}

export function useSaveOnboardingStep() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: SaveOnboardingStepParams) => {
      const { organization_id, ...body } = params
      const axios = getOrganizationAxios()
      const { data } = await axios.patch(
        `/api/internal/organizations/${organization_id}/update_onboarding`,
        body
      )
      return data
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["onboarding", variables.organization_id],
      })
    },
  })
}
